<template>
  <div>

    <div class="template-container">
      <div class="header-container">
        <div>Bokslutsmöte</div>
      </div>

      <div class="question-container">
        <div class="size3 w-bold">Vilket bolag vill du basera presentationen på?</div>
        <div class="flex-div">
          <div class="flex-two">
            <select v-model="company" class="size3 mt-10">
              <option value="">Välj bolag</option>
              <option value="Testhouse Nordic AB">Testhouse Nordic AB</option>
              <option value="Bolagskompassen AB">Bolagskompassen AB</option>
            </select>
          </div>
          <div class="flex-one"></div>
        </div>
      </div>

      <div v-if="company !== ''" class="question-container">
        <div class="size3 w-bold">Vilken SIE-import vill du använda?</div>
        <div class="flex-div">
          <div class="flex-two">
            <select class="size3 mt-10">
              <option value="Testhouse Nordic AB">2022-12, importerad 2023-01-19 kl 15:09</option>
              <option value="Testhouse Nordic AB">2022-12, importerad 2023-01-19 kl 16:13</option>
            </select>
          </div>
          <div class="flex-one"></div>
        </div>
      </div>


      <div v-if="company !== ''">
        <!-- <div class="flex-div"> -->
          <b-form-checkbox class="mb-3 flex-one" v-model="unlockedTemplate" switch size="lg">Mallen är <span v-if="unlockedTemplate">upp</span>låst</b-form-checkbox>   

          <div class="helper flex-one">
            <div v-if="!unlockedTemplate">En låst mall använder sig av fördefinierat innehåll där endast ett fåtal delar kan redigeras. Enklast är att använda <span class="keyboard">tab</span> för att snabbt komma till nästa del.</div>
            <div v-if="unlockedTemplate">Med en upplåst mall får du större frihet och kan ta bort, lägga till och ändra i de olika sidkomponenterna. Viss automatisk formatering försvinner dock vilket ställer högre krav på att du tittar igenom det färdiga resultatet.</div>
          </div>
        <!-- </div> -->

        <div class="start-here">
          <div class="size3">Fyll i presentationen</div>
          <div><I name="pointer-down2"></I></div>
        </div>
      </div>
    </div>

    <div class="page-container" >
      <div class="header-container">
        <div>Sidrubrik</div>
        <div><I name="lock" class="icon-button"></I></div>
      </div>

      <div class="question-container">        
        <div class="edit-content">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Presentationens namn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla presentationen?</div>
            <input type="text" ref="slideHeadline" class="size3" value="Bokslutsmöte" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
          </div>
        </div>
      </div>
    </div>
    
    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla fliken?</div>
            <input type="text" ref="contentList" class="size3" value="Agenda" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3" value="Ekonomisk genomgång" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Bokslutsarbetet" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Analys & Ägarfrågor" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Övrigt" :disabled="!unlockedTemplate">
            <input type="text" class="size3" :disabled="!unlockedTemplate">
          </div>
        </div>
      </div>
    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        
        <div class="edit-content">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Sidrubrik</div>
            <div v-else class="size3 w-bold">Vad vill du kalla sidan?</div>
            <input type="text" ref="slideHeadline" class="size3" value="Ekonomisk genomgång" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
          </div>
        </div>

      </div>
    </div>



    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Resultatöversikt" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3" value="Omsättning på 129,9 mkr" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Perioden avser 18 månader" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Rörelsemarginal på 9,1 mkr" :disabled="!unlockedTemplate">
            <input type="text" class="size3" :disabled="!unlockedTemplate">
            <input type="text" class="size3" :disabled="!unlockedTemplate">
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Nettoomsättning" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Rörelsemarginal" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Senaste året" :disabled="!unlockedTemplate">
            </div>

            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Balansöversikt" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3" value="Tillgångar på 29,5 mkr" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Justerat eget kapital på 18,7 mkr" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Soliditet på 63,2 %" :disabled="!unlockedTemplate">
            <input type="text" class="size3" :disabled="!unlockedTemplate">
            <input type="text" class="size3" :disabled="!unlockedTemplate">
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Balansomslutning" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Soliditet" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Senaste året" :disabled="!unlockedTemplate">
            </div>

            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Likviditetsöversikt" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3" value="Kassa & bank på 13,3 mkr" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Kassalikviditet på 248,8 %" :disabled="!unlockedTemplate">
            <input type="text" class="size3" value="Inga räntebärande skulder" :disabled="!unlockedTemplate">
            <input type="text" class="size3" :disabled="!unlockedTemplate">
            <input type="text" class="size3" :disabled="!unlockedTemplate">
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Kassa & bank" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Kassalikviditet" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Räntebärande skulder" :disabled="!unlockedTemplate">
            </div>

            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        
        <div class="edit-content">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Sidrubrik</div>
            <div v-else class="size3 w-bold">Vad vill du kalla sidan?</div>
            <input type="text" ref="slideHeadline" class="size3" value="Bokslutsarbetet" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
          </div>
        </div>

      </div>
    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Noteringar" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3" value="Korrekta skatter">
            <input type="text" class="size3" value="Lönekrav uppfyllt">
            <input type="text" class="size3" value="Tydligare dokumentation">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Att signera" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Att göra" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        
        <div class="edit-content">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Sidrubrik</div>
            <div v-else class="size3 w-bold">Vad vill du kalla sidan?</div>
            <input type="text" ref="slideHeadline" class="size3" value="Analys & Ägarfrågor" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
          </div>
        </div>

      </div>
    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Bolagskompass" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Flerårskompass" :disabled="!unlockedTemplate">
            </div>
            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-container">
        <div>
          <div class="edit-content mt-20">
            <div class="flex-one">
              <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
              <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
              <input type="text" ref="contentList" class="size3" value="Hållbarhetskompass" :disabled="!unlockedTemplate">
            </div>

            <div class="flex-one">
              <div class="size3 w-bold">Diagram</div>
              <div class="chart-container"></div>
              <div v-if="unlockedTemplate" class="delete-chart">Radera diagram</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Ägarfrågor" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3" value="Öka pensionsinsättningar?">
            <input type="text" class="size3" value="Tjänstebil?">
            <input type="text" class="size3" value="Ägardirektiv">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Framtidsutsikter" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Utdelning" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Framtidens nyckeltal" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        
        <div class="edit-content">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Sidrubrik</div>
            <div v-else class="size3 w-bold">Vad vill du kalla sidan?</div>
            <input type="text" ref="slideHeadline" class="size3" value="Övrigt" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
          </div>
        </div>

      </div>
    </div>

    <div class="page-container">
      <div class="header-container">
        <div>Sidrubrik</div>
        <div v-if="!unlockedTemplate"><I name="cog2" class="icon-button"></I></div>
        <div v-if="unlockedTemplate">
          <I name="trash2" class="icon-button"></I>
          <I name="chevrons-expand-vertical" class="icon-button"></I>
        </div>
      </div>

      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Övriga frågor" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3" value="Kassaflödesanalys?">
            <input type="text" class="size3" value="Hållbarhetsredovisning?">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Feedback" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Nästa möte" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
      <div class="question-container">
        <div class="edit-content mt-20">
          <div class="flex-one">
            <div v-if="!unlockedTemplate" class="size3 w-bold">Fliknamn</div>
            <div v-else class="size3 w-bold">Vad vill du kalla denna flik?</div>
            <input type="text" ref="contentList" class="size3" value="Våra tjänster" :disabled="!unlockedTemplate">
          </div>
          <div class="flex-one">
            <div class="size3 w-bold">Skriv dina punkter här</div>
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
            <input type="text" class="size3">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Slide',

  data() {
    return {
      unlockedTemplate: false,
      showTab: true,
      ourServices: true,
      company: '',
    };
  },
};
</script>

<style lang="scss" scoped>

input, textarea, select {
  accent-color: col('colors.Primary');
  margin-top: 1rem;
  padding: 0.2rem 0.5rem;
  border: 1px solid col('colors.LightGrey');
  &:focus {
    outline-color: col('colors.Secondary');
    background-color: rgba(col('colors.Secondary'), 0.15);
  }
}

input[type=radio] {
  width: 1rem;
  height: 1rem;
}

input[type=text] {
  margin-top: 1rem;
}

input:disabled {
  background-color: col('colors.Light');
  color: col('colors.DarkGrey');
}

label {
  margin: 1rem 2rem 1rem 0.5rem;
}


.template-container,
.page-container {
  scroll-margin-top: 2rem;
  min-height: calc(100vh - 9rem);
  border-bottom: 1px solid col('colors.LightGrey');
}
.template-container {
  position: relative;
}

.header-container {
  display: flex;
  justify-content: space-between;
  margin: 2rem 0 1rem;
  font-size: 1.25rem;
  font-weight: 300;
}

.question-container {
  padding: 1rem;
  border: 1px solid col('colors.Light');
  background-color: col('colors.Light');
  transition: 0.5s;
  &:focus-within {
    border-color: col('colors.Primary');
    background-color: rgba(col('colors.White'), 1); 
  }
}

.flex-div,
.edit-content {
  display: flex;
  flex-direction: row;
  gap: 2rem;
}

.flex-one {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.flex-two {
  flex: 2;
  display: flex;
  flex-direction: column;
}


.icon-button {
  position: relative;
  top: -0.5rem;
  right: 0.5rem;
  margin: 0 0.5rem;
  transition: 0.5s;
  &:hover {
    cursor: pointer;
    color: col('colors.Secondary');
  }
}

.helper {
  border: 1px solid col('colors.Primary');
  border-left-width: 0.3rem;
  padding: 1rem;
  background-color: rgba(col('colors.Primary'), 0.15);
  margin: 1rem 0;

  & div + div {
    margin-top: 1rem;
  }
}

.less-width {
  max-width: 60%;
}

.tab {
  color: col('colors.DarkGrey');
  text-transform: uppercase;
}

.tab-container {
  display: flex;
  flex-basis: 100%;
  justify-content: space-between;
}

.add-tab {
  transition: 0.5s;
  &:hover {
    cursor: pointer;
    color: col('colors.Secondary');
  }
}

.delete-tab {
  color: col('colors.LightGrey');
  margin-right: 1rem;
}

.chart-container {
  margin-top: 1rem;
  width: 100%;
  aspect-ratio: 16 / 11;
  background-color: col('colors.Primary');
  border: 1px solid col('colors.DarkGrey');
}

.delete-chart {
  margin-left: auto;
  transition: 0.5s;
  &:hover {
    cursor: pointer;
    color: col('colors.Negative');
    text-decoration: underline;
  }
}

.hidden {
  visibility: hidden;
}

.page-container.hidden {
  scroll-margin-top: 0;
  min-height: 0;
  height: 0;
  margin-top: calc(-2rem - 1px);
}

.question-container.hidden {
  min-height: 0;
  height: 0;
  padding: 0;
}

.start-here {
  position: absolute;
  font-weight: 600;
  color: col('colors.Black');
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  & div + div {
    margin-top: 1rem;
  }
}

.keyboard {
  background-color: col('colors.Light');
  padding: 0.1rem 0.5rem;
  border: 1px solid col('colors.DarkGrey');
  border-radius: 0.2rem;
}

.mt-10 {
  margin-top: 1rem;
}

</style>